var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.53105 19.7709C9.82398 20.0521 9.82398 20.5079 9.53105 20.7891C9.23812 21.0703 8.7632 21.0703 8.47027 20.7891L3.21969 15.7491C3.07903 15.6141 3 15.431 3 15.24C3 15.049 3.07903 14.8659 3.2197 14.7309L8.47027 9.69091C8.7632 9.40973 9.23813 9.40974 9.53105 9.69091C9.82398 9.97209 9.82397 10.428 9.53105 10.7091L5.56095 14.52L16.2495 14.52C17.1115 14.52 17.9383 14.1913 18.5478 13.6062C19.1574 13.0211 19.4998 12.2275 19.4998 11.4L19.4998 3.72C19.4998 3.32235 19.8357 3 20.2499 3C20.6642 3 21 3.32235 21 3.72L21 11.4C21 12.6094 20.4995 13.7692 19.6086 14.6244C18.7177 15.4796 17.5094 15.96 16.2495 15.96L5.56094 15.96L9.53105 19.7709Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enter.1f69fa41733314d6c3dce2570cff3cab.svg";